import { messages as portugueseMessages } from "./pt";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as arabicMessages } from "./ar";
import { enExtra } from "./en.extra";
import { esExtra } from "./es.extra";
import { aerosExtra } from "./aeros.extra";

// Mescla um mapa flat ("a.b.c": "x") dentro do objeto aninhado de traduções.
const mergeFlat = (target, flat) => {
  Object.entries(flat).forEach(([key, value]) => {
    const parts = key.split(".");
    let node = target;
    parts.slice(0, -1).forEach((p) => {
      if (!node[p] || typeof node[p] !== "object") node[p] = {};
      node = node[p];
    });
    if (!(parts[parts.length - 1] in node)) node[parts[parts.length - 1]] = value;
  });
  return target;
};

const messages = {
  ...portugueseMessages,
  ...englishMessages,
  ...spanishMessages,
  ...arabicMessages,
};

mergeFlat(messages.pt.translations, aerosExtra.pt);
mergeFlat(messages.en.translations, enExtra);
mergeFlat(messages.en.translations, aerosExtra.en);
mergeFlat(messages.es.translations, esExtra);
mergeFlat(messages.es.translations, aerosExtra.es);

export { messages };
